<template>
    <div id="printReport">
        <div class="container">
            <div class="col-sm-2">
                <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
            </div>
            <div class="col-sm-8">
                <h3 class="text-center">Relatório de Inadimplência por Cancelamento</h3>
            </div>
            <div class="col-sm-2"></div>
        </div>
        <br />

        <div class="row" id="conteudo">
            <div class="col-sm-12">
                <div class="panel panel-defaul">
                    <div class="panel-body">
                        <div class="row" id="dados">
                            <div class="col-md-3">
                                <label>Loja</label>
                                <br />
                                {{ !form.branche_id ? 'TODAS' : store_branch}}
                            </div>
                            <div class="col-md-3">
                                <label>Periodo ({{ form.date_filter == 'cancel_at' ? 'Data do Cancelamento' : (form.date_filter == 'deployment_at' ? 'Data Alocação' : 'Data da Venda') }})</label>
                                <br />
                                <div class="col-md-4">{{ form.interval.length ? moment(form.interval[0]).format('DD/MM/YYYY') : 'Todas' }} à {{ form.interval.length ? moment(form.interval[1]).format('DD/MM/YYYY') : 'Todas' }}</div>
                            </div>
                            <div class="col-md-3">
                                <label>Administradora</label>
                                <br />
                                {{ !form.administrator_id ? 'TODAS' : administrator }}
                            </div>
                            <div class="col-md-3">
                                <label>Vendedor</label>
                                <br />
                                {{ !form.salesman_id ? 'TODAS' : salesman }}
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>

        <tableReport
                v-if="helperItens.length"
                title_header="Loja"
                :helperTitle="'Sintético - '+report_type"
                :helperHeader="helperHeader"
                :helperItens="helperItens"
                :headerItens="names"
                :title="'Analítico - '+item_report"
                :header="firstHeader"
                :itens="dataReport"
                :show_detail="show_detail"
                :showDetails="showDataDetails"
                :twoTables="true"
        />
        <div class="container dont-print">
            <div class="col-md-12 text-center">
                <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
                <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
                <button type="button" v-show="detail.length" @click="excel()" class="btn btn-fill btn-success">Excel</button>
            </div>
        </div>
    </div>
</template>
<script>

    import Vue from "vue";

    import tableReport from "../../../components/report/Table";

    export default {
        components: {
            tableReport
        },
        computed: {

            user_auth_name(){
                return this.$store.state.auth.user.name.toUpperCase();
            },
            branches() {
                return this.$store.state.defaults.branches;
            },
        },
        data() {
            return {
                salesman: null,
                report_type: null,
                item_report: null,
                helperItens: [],
                firstHeader: [{
                    title: 'Cliente',
                    name: 'client',
                    clickCustom: true,
                    linkFunc: this.redirectProposal,
                    calc: 'none',
                    removeTotal: true
                },
                    {
                        title: 'Contrato',
                        name: 'contract',
                        click: false,
                        calc: 'none',
                        notToDecimal: true
                    },
                    {
                        title: 'Administradora',
                        name: 'administrator',
                        click: false,
                        calc: 'none',
                    },
                    {
                        title: 'Grupo/Cota',
                        name: 'quota_group' ,
                        click: false,
                        calc: 'none',
                    },
                    {
                        title: 'Data Venda',
                        name: 'sale_at',
                        click: false,
                        calc: 'none',
                    },
                    {
                        title: 'Data Cancelamento',
                        name: 'cancel_at',
                        click: false,
                        calc: 'none',
                    },
                    {
                        title: 'Carta',
                        name: 'value',
                        click: false,
                        calc: 'sum'
                    }
                ],
                helperHeader: [{
                    title: null,
                    name: 'vendedor',
                    click: false,
                    calc: 'none',
                    removeTotal: true

                },
                    {
                        title:  'Cota',
                        name:  'cota',
                        click: false,
                        calc: 'sum',
                        notToDecimal: true
                    },
                    {
                        title:  'Crédito',
                        name:  'credito',
                        click: false,
                        calc: 'sum'
                    },
                    {
                        title:  'Canceladas',
                        name:  'canceladas',
                        click: true,
                        calc: 'sum',
                        notToDecimal: true
                    },
                    {
                        title:  'Valor Cancelado',
                        name:  'valor_cancelado',
                        click: false,
                        calc: 'sum'
                    },
                    {
                        title:  'Inadimplência %',
                        name:  'inadimplencia',
                        click: false,
                        calc: 'custom',
                        calcCustom: this.calcToNonPayment
                    }
                ],
                dataReport: [],
                indexReport: 0,
                names: [],
                moment: Vue.moment,
                administrator: null,
                dataAdministrador: [],
                store_branch: null,
                date_reference : null,
                form: {
                    interval: [],
                },
                show_detail : false,
                branche_id_ : null,
                detail: []
            };
        },
        methods: {

            async getDataSalesmen() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch("users/all");

                response.then(function(_salesmen) {
                    var salesman = _salesmen.find(
                        salesman => salesman.id === self.form.salesman_id
                    );
                    if (salesman !== undefined) {
                        self.salesman = salesman.name;
                    }
                    self.$root.$emit("onLoading");
                });

                response.catch(function() {
                    self.$root.$emit("onLoading");
                });

            },
            redirectProposal(data) {
                window.open('/proposals/'+data.proposal_id, '_blank');
            },
            calcToNonPayment(data, head) {
                let quota = 0;
                let cancel = 0;

                data.forEach(element => {
                    quota += element['cota'];
                    cancel += element['canceladas'];
                });
                return ((cancel * 100) / quota);
            },
            async showDataDetails(data, index) {
                const self = this;
                this.indexReport = index;
                self.dataReport = [];

                if(data.hasOwnProperty('dataCancel')) {
                    self.dataReport = data.dataCancel;
                }
                if(self.form.report_type === 1) {
                    self.item_report = data.vendedor
                } else if (self.form.report_type === 2) {
                    self.item_report = data.time
                } else {
                    self.item_report = data.loja
                }

                self.show_detail = true;

            },
            close() {
                window.opener.focus();
                window.close();
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');
                await response.then(async (data) => {
                    self.dataAdministrador = await data;
                    self.$root.$emit("onLoading");
                });
                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            async getData(){
                var self = this;
                self.$root.$emit("onLoading");
                const response = self.$store.dispatch('reports/nonPaymentCancellation', self.form);

                response.then(function (res) {
                    console.log('res ', res, ' obje ', Object.values(res))
                    self.helperItens = Object.values(res);
                    self.helperItens.forEach((value, index) => {
                        if(!self.names.includes(value.vendedor)) {
                            self.names.push(value.vendedor);
                        }
                    })
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            print() {
                window.print();
            },
            excel() {
                var nome = "RELATÓRIO DE INADIMPLÊNCIA POR CANCELAMENTO";
                var htmlPlanilha =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
                    nome +
                    "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
                    nome +
                    "</title></head><body><table>" +
                    document.getElementById("tabela").innerHTML + document.getElementById("tabela2").innerHTML +
                    "</table>";
                var htmlBase64 = btoa(htmlPlanilha);
                var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
                var hyperlink = document.createElement("a");
                hyperlink.download = "Relatório de Inadimplência Mensal";
                hyperlink.href = link;
                hyperlink.style.display = "none";
                document.body.appendChild(hyperlink);
                hyperlink.click();
                document.body.removeChild(hyperlink);
            },

        },
        async beforeMount() {
            var self = this;
            await self.getDataAdministrators();
            self.form = await JSON.parse(self.$route.query.form);

            if(self.form.report_type === 1) {
                self.helperHeader[0].title = 'Vendedor'
                self.report_type = 'Vendedor'
            } else if (self.form.report_type === 2) {
                self.helperHeader[0].title = 'Equipe'
                self.helperHeader[0].name = 'time'
                self.report_type = 'Equipe'
            } else {
                self.helperHeader[0].title = 'Loja'
                self.helperHeader[0].name = 'loja'
                self.report_type = 'Loja'
            }

            await self.getDataSalesmen();
            await self.getData();
            self.store_branch   = self.form.branche_id ? self.branches.find(item => item.id === self.form.branche_id).name.toUpperCase() : null;
            self.administrator   = self.form.administrator_id ? self.dataAdministrador.find(item => item.id === self.form.administrator_id).name.toUpperCase() : null;
        }
    };
</script>
<style type="scss">
    @media print {
        .dont-print {
            display: none;
        }
    }
</style>

<style scoped>

</style>
